// http://vuex.vuejs.org/en/mutations.html#using-constants-for-mutation-types
export const SET_TOKEN = 'Auth//SET_TOKEN'
export const SET_USER = 'Auth//SET_USER'
export const SET_BASE_URL = 'Auth/SET_BASE_URL'


// WEBPACK FOOTER //
// ./src/app/auth/vuex/mutations-types.js